import ContestCard from'./ContestCardDefault';export default ContestCard;